// @flow

import fetchApi from '../middleware/api';

export const fetchGroups = () => fetchApi({ endpoint: '/api/v1/groups' });
